import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Abdul Mohammed",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.5/5",
    experience: "18 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Fistula Specialist"
  },
  {
    name: "Dr. Prudhvinath",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Laser Fistula Surgeon"
  },
  {
    name: "Dr. Anuj Kumar Patel",
    qualification: "MBBS, MS-General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Proctology Expert"
  },
  {
    name: "Dr. Ravi Sharma",
    qualification: "MBBS, MS - Surgery",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "12 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Fistula Treatment"
  },
  {
    name: "Dr. Meera Iyer",
    qualification: "MBBS, DNB - Proctology",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "10 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Senior Proctologist"
  },
  {
    name: "Dr. Karthik Rao",
    qualification: "MBBS, MS - Surgery",
    fee: "FREE Consultation",
    rating: "4.5/5",
    experience: "16 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Fistula & Piles Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Fistula Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Connect with top proctology specialists and book FREE consultations for advanced fistula treatment.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Appointment
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const Fistula = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Fistula Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Revolutionary Minimally Invasive Laser Treatment with 98% Success Rate. No Cutting, No Stitches, Faster Recovery.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              View Treatment Options
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>8,500+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Successful Treatments</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>98%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>45 min</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>48 hrs</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Back to Work</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "causes", label: "Causes", icon: "🎯" },
              { id: "types", label: "Types", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "recovery", label: "Recovery", icon: "🔄" },
              { id: "prevention", label: "Prevention", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Fistula Treatment</span>
            </h2>
          </div>

          {/* What is Fistula */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Anal Fistula
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                An anal fistula is an abnormal tunnel-like connection that develops between the inside of the anus 
                and the skin around it. It usually forms after an anal abscess (a collection of pus) drains either 
                spontaneously or through surgical incision.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>How Fistula Develops</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Starts as an anal abscess → Abscess bursts or is drained → Tunnel forms connecting 
                      anal canal to skin → Persistent drainage and infection occur.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Why Treatment is Essential</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Fistulas don't heal on their own and can lead to recurrent abscesses, persistent drainage, 
                      skin irritation, and in rare cases, cancer if left untreated for many years.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Symptoms */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Symptoms Guide
            </h3>

            <div className="row">
              {[
                {
                  title: "Persistent Drainage", 
                  description: "Constant pus or blood-stained discharge from an opening near the anus",
                  details: "May stain underwear and cause embarrassment"
                },
                {
                  title: "Pain & Discomfort", 
                  description: "Throbbing pain that worsens during sitting or bowel movements",
                  details: "Pain may temporarily relieve after drainage"
                },
                {
                  title: "Swelling & Redness", 
                  description: "Recurrent swelling and inflammation around the anal area",
                  details: "Due to repeated abscess formation"
                },
                {
                  title: "Skin Irritation", 
                  description: "Itching, redness and skin breakdown around the anal opening",
                  details: "Caused by constant moisture from drainage"
                },
                {
                  title: "Fever & Malaise", 
                  description: "Systemic symptoms during acute infection phases",
                  details: "Indicates active infection requiring immediate attention"
                },
                {
                  title: "Bowel Movement Issues", 
                  description: "Pain during defecation and sometimes difficulty passing stools",
                  details: "Due to inflammation and pain around anal sphincter"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Types of Fistula */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Anal Fistula
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Intersphincteric",
                    description: "Most common type (45%) - passes between internal and external sphincter muscles",
                    complexity: "Low Complexity"
                  },
                  {
                    type: "Transphincteric",
                    description: "Passes through both sphincter muscles - higher risk of incontinence",
                    complexity: "Medium Complexity"
                  },
                  {
                    type: "Suprasphincteric",
                    description: "Travels above the sphincter complex - rare and complex to treat",
                    complexity: "High Complexity"
                  },
                  {
                    type: "Extrasphincteric",
                    description: "Passes outside sphincter mechanism - usually from Crohn's disease or trauma",
                    complexity: "Very High Complexity"
                  }
                ].map((fistulaType, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {fistulaType.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {fistulaType.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {fistulaType.complexity}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Anal abscess (most common cause - 90% of cases)</li>
                      <li style={{ marginBottom: "10px" }}>Crohn's disease and inflammatory bowel disease</li>
                      <li style={{ marginBottom: "10px" }}>Trauma or injury to anal area</li>
                      <li style={{ marginBottom: "10px" }}>Radiation therapy for pelvic cancers</li>
                      <li>Tuberculosis and other infections</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Previous anal abscess</li>
                      <li style={{ marginBottom: "10px" }}>Chronic constipation or diarrhea</li>
                      <li style={{ marginBottom: "10px" }}>Weakened immune system</li>
                      <li style={{ marginBottom: "10px" }}>Smoking and poor hygiene</li>
                      <li>Family history of fistulas</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Advanced Treatment Options
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Laser Fistula Treatment (FILAC)
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Fistula Tract Laser Closure (FILAC) is a revolutionary minimally invasive procedure that uses 
                    laser energy to precisely seal the fistula tract from inside, preserving sphincter function 
                    and ensuring faster recovery.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Key Benefits:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Sphincter muscle preservation</li>
                          <li style={{ marginBottom: "8px" }}>No cutting or stitches</li>
                          <li style={{ marginBottom: "8px" }}>45-minute procedure</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Minimal pain and bleeding</li>
                          <li style={{ marginBottom: "8px" }}>Day care procedure</li>
                          <li style={{ marginBottom: "8px" }}>98% success rate</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Traditional Surgical Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Sphincter-Preserving Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Fistulotomy:</strong> Laying open the tract for simple fistulas</li>
                      <li style={{ marginBottom: "10px" }}><strong>Seton Placement:</strong> Thread through tract for drainage</li>
                      <li style={{ marginBottom: "10px" }}><strong>Advancement Flap:</strong> Tissue flap to cover internal opening</li>
                      <li style={{ marginBottom: "10px" }}><strong>LIFT Procedure:</strong> Ligation of intersphincteric fistula tract</li>
                      <li><strong>VAAFT:</strong> Video-assisted anal fistula treatment</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Considerations:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Choice depends on fistula complexity</li>
                      <li style={{ marginBottom: "10px" }}>Risk of incontinence with some procedures</li>
                      <li>Recovery time varies 2-6 weeks</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recovery Process */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Recovery Timeline After Laser Treatment
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-3",
                    title: "Immediate Post-Op",
                    activities: ["Mild discomfort managed with painkillers", "Light walking encouraged", "Sitz baths 2-3 times daily", "Soft diet and plenty of fluids"]
                  },
                  {
                    period: "Week 1-2",
                    title: "Early Recovery",
                    activities: ["Return to desk work", "Avoid heavy lifting", "Continue sitz baths", "Dressing changes as needed"]
                  },
                  {
                    period: "Week 3-4",
                    title: "Advanced Healing",
                    activities: ["Resume most activities", "Light exercise okay", "Minimal drainage", "Follow-up with surgeon"]
                  },
                  {
                    period: "Month 2+",
                    title: "Complete Recovery",
                    activities: ["Full activities resumed", "No restrictions", "Complete wound healing", "Normal bowel function"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention Section */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Lifestyle Management
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Preventing Recurrence</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Treat anal abscesses promptly</li>
                      <li style={{ marginBottom: "10px" }}>Manage underlying conditions (Crohn's, diabetes)</li>
                      <li style={{ marginBottom: "10px" }}>Maintain proper anal hygiene</li>
                      <li>Avoid prolonged sitting on toilet</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Healthy Bowel Habits</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>High-fiber diet to prevent constipation</li>
                      <li style={{ marginBottom: "10px" }}>Adequate hydration (8-10 glasses water daily)</li>
                      <li style={{ marginBottom: "10px" }}>Regular exercise for bowel regularity</li>
                      <li>Don't ignore urge for bowel movement</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Is laser treatment for fistula better than traditional surgery?",
                  answer: "Yes, laser treatment (FILAC) is superior because it preserves sphincter function, causes minimal pain, has faster recovery, and lower recurrence rates compared to traditional surgery."
                },
                {
                  question: "What is the success rate of laser fistula treatment?",
                  answer: "Laser fistula treatment has a success rate of 95-98% for most types of anal fistulas, with significantly lower risk of incontinence compared to traditional methods."
                },
                {
                  question: "How long does it take to recover from fistula laser surgery?",
                  answer: "Most patients return to desk work within 2-3 days and resume normal activities within 1-2 weeks. Complete healing typically occurs within 4-6 weeks."
                },
                {
                  question: "Can fistula recur after laser treatment?",
                  answer: "While recurrence is possible with any fistula treatment, laser treatment has the lowest recurrence rate (2-5%) when performed by experienced surgeons and combined with proper post-operative care."
                },
                {
                  question: "Is the laser procedure painful?",
                  answer: "Laser fistula treatment is performed under anesthesia and is virtually painless. Most patients experience only mild discomfort during recovery, easily managed with over-the-counter pain medication."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to Get Rid of Fistula Forever?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Don't let fistula affect your quality of life. Book your FREE consultation with our expert surgeons today!
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Fistula;